<template>
    <div class="billing-center-box">
        <van-nav-bar title="已核销福利" />
        <div class="billing-center-content">
            <!-- // 暂时隐藏 -->
            <van-search
                v-model="paramas.keyWord"
                left-icon=""
                show-action
                placeholder="搜索核销用户昵称，核销管理员姓名"
                input-align="left"
            >
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
            <!-- <div class="search-time">
                <div class="time-input">
                    <span class="start-time" @click="startShow = true">{{ startTiem }} <van-icon name="arrow-down"/></span>
                    <span class="middle-text">至</span>
                    <span class="end-time" @click="endShow = true">{{ endTime }} <van-icon name="arrow-down"/></span>
                </div>
                <van-popup v-model="startShow" position="bottom">
                    <van-datetime-picker
                        v-model="currentDate"
                        @confirm="onConfirmtime($event, 'startTiem', 'startShow')"
                        @cancel="show = false"
                        type="date"
                        title="选择年月日"
                        :min-date="minDate"
                        :max-date="maxDate"
                    />
                </van-popup>
                <van-popup v-model="endShow" position="bottom">
                    <van-datetime-picker
                        v-model="currentDate"
                        @confirm="onConfirmtime($event, 'endTime', 'endShow')"
                        @cancel="show = false"
                        type="date"
                        title="选择年月日"
                        :min-date="minDate"
                        :max-date="maxDate"
                    />
                </van-popup>
            </div> -->
            <van-tabs v-model="paramas.type" @click="tabOnClick">
                <van-tab title="本机构" name="0">
                    <ul class="coupon-box">
                        <li class="coupon-item" v-for="(coupon, index) in couponList" :key="index">
                            <div class="coupon-time">{{ coupon.createTime }}</div>
                            <div class="coupon-content">
                                <div class="coupon-name">{{ coupon.boonName }}</div>
                                <div class="coupon-description">
                                    <!-- <p>福利用途: 福利用途</p> -->
                                    <p>券类型: {{ coupon.welfareType | formatWelfareType }}</p>
                                    <!-- <p v-if="coupon.verificationType != '0'">核销方式: {{ coupon.verificationType | formatWelType }}</p> -->
                                    <!-- <p>使用积分: {{ coupon.exchangePrice }} 积分</p> -->
                                    <p>核销时间: {{ coupon.createTime ? coupon.createTime : coupon.verificationTime }}</p>
                                    <p>核销用户: {{ coupon.usersName }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="本门店" name="1">
                    <ul class="coupon-box">
                        <li class="coupon-item" v-for="(coupon, index) in couponList" :key="index">
                            <div class="coupon-time">{{ coupon.createTime }}</div>
                            <div class="coupon-content">
                                <div class="coupon-name">{{ coupon.boonName }}</div>
                                <div class="coupon-description">
                                    <p>福利用途: 福利用途</p>
                                    <p>福利名称: {{ coupon.welfareType | formatWelfareType }}</p>
                                    <p>使用积分: {{ coupon.exchangePrice }} 积分</p>
                                    <p>抢购用户: {{ coupon.usersName }}</p>
                                    <p>兑换时间: {{ coupon.createTime }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import { reqMerchant, reqWriteOffList } from '../api/merchant';
import moment from 'moment';
export default {
    data() {
        return {
            startShow: false,
            endShow: false,
            date: '',
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2028, 10, 1),
            currentDate: new Date(),
            startTiem: '选择开始时间',
            endTime: '选择结束时间',
            couponList: [],
            mallOrgID: '', // 商家id
            chargePhone: '',
            businessUsersID: '', // businessUsersID
            paramas: {
                keyWord: '',
                type: 0 // 0 优惠券，1 现金券
            }
        };
    },
    filters: {
        formatWelfareType(type) {
            switch (type) {
                case '2':
                    return '折扣券';
                case '3':
                    return '兑换券';
                case '4':
                    return '满减券';
                case '5':
                    return '现金券';
                default:
                    return '未知';
            }
        },
        formatWelType(type) {
            switch (type) {
                case '1':
                    return '扫码验券';
                case '2':
                    return '输码验券';
                default:
                    return '未知';
            }
        }
    },
    mounted() {
        this.reqMerchantData();
    },
    methods: {
        // 获取商家信息
        reqMerchantData() {
            reqMerchant({ phone: this.$globalData.phone1 })
                .then(res => {
                    if (res.result === 200) {
                        const { businessUsersID, mallOrgID, chargePhone } = res.data;
                        this.chargePhone = chargePhone;
                        this.mallOrgID = mallOrgID;
                        this.businessUsersID = businessUsersID;
                        this.getCouponList();
                    } else {
                        this.$toast.fail(res.data);
                    }
                })
                .catch(() => {
                    this.$toast.fail('获取商家信息失败!');
                });
        },
        // 切换优惠券
        tabOnClick(e) {
            this.getCouponList();
        },
        // 搜索
        onSearch() {
            this.getCouponList();
        },
        // 获取券列表
        getCouponList() {
            reqWriteOffList({ phone: this.$globalData.phone1, ...this.paramas })
                .then(res => {
                    this.couponList = res.data.data || [];
                })
                .catch(() => {
                    this.$toast.fail('获取券信息失败!');
                });
        },
        onConfirmtime(e, time, show) {
            e = moment(e).format('YYYY-MM-DD');
            this[time] = e;
            this[show] = false;
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #eeeeee;

    .billing-center-content {
        .search-time {
            .time-input {
                display: flex;
                align-content: center;
                justify-content: center;
                padding: 15px 0;
                span {
                    font-size: 12px;
                    color: #747474;
                    line-height: 14px;
                }

                .start-time,
                .end-time {
                    user-select: none;
                    cursor: pointer;
                }
                .middle-text {
                    margin: 0 10px;
                    color: #393939;
                    font-size: 14px;
                }
            }
        }
        .coupon-box {
            height: calc(100vh - 89px - 55px);
            overflow: auto;
            .coupon-item {
                .coupon-time {
                    font-size: 14px;
                    padding: 10px 15px;
                }

                .coupon-content {
                    padding: 0 15px 20px;
                    background-color: #ffffff;
                    .coupon-name {
                        font-size: 20px;
                        padding: 10px 0;
                        margin-bottom: 15px;
                        border-bottom: 1px solid #eeeeee;
                    }
                    .coupon-description {
                        p {
                            margin: 0 0 5px;
                            font-size: 14px;
                            color: #565454;
                        }
                    }
                }
            }
        }
    }
}
</style>
